import MessagingBase from './messaging-base';

export default class MessagingConversation extends MessagingBase {
  serialize(snapshot) {
    if (snapshot.isNew) return this.#serializeNewConversation(snapshot);

    let json = super.serialize(...arguments);
    // Conversation updates currently only accept display_name.
    json.data.attributes = {
      'display_name': json.data.attributes.display_name ?? null,
    };
    delete json.data.relationships;
    return json;
  }

  #serializeNewConversation(snapshot) {
    const contacts = snapshot.hasMany('contacts') || [];

    return {
      data: {
        type: 'conversations',
        attributes: {
          contacts: contacts.map(contactSnapshot => this.#serializeCreateContact(contactSnapshot)),
        },
      },
    };
  }

  #serializeCreateContact(contactSnapshot) {
    const attrs = contactSnapshot.attributes();
    const coupleSnapshots = contactSnapshot.hasMany('couple') || [];
    const attributes = {
      'external_id': attrs.externalId,
      'external_scope': attrs.externalScope,
      'organization_id': attrs.organizationId,
      ...(attrs.name && { name: attrs.name }),
    };

    if (coupleSnapshots.length) {
      attributes.couple = coupleSnapshots.map(partner => this.#serializeCreateContact(partner));
    }

    return {
      type: 'contacts',
      attributes,
    };
  }
}
